class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
  }

  connectedCallback() {
    this.addEventListener("menu:open", (e) => {
      if (!e.detail) return;
      if (e.detail.context === "header-search") {
        setTimeout(() => {
          this.input.focus();
          this.input.setSelectionRange(
            this.input.value.length,
            this.input.value.length,
          );

          document.activeElement;
        }, 500);
      }
    });

    document.addEventListener("menu:close", (e) => {
      if (!e.detail) return;
      if (e.detail.context === "header-search") {
        this.input.blur();
      }
    });

    this.input.addEventListener("input", () => {
      if (this.input.value) {
        const totalCharacters = this.input.value.length;
        this.input.style.width = `${totalCharacters + 2}ch`;
      } else {
        this.input.style.width = `180px`;
      }
    });
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
